import { render, staticRenderFns } from "./TarefasAbertasComponent.vue?vue&type=template&id=01d66546"
import script from "./TarefasAbertasComponent.vue?vue&type=script&lang=js"
export * from "./TarefasAbertasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports